import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ReactComponent as Logo } from '../assets/86 ICE La Migra_Primary Identity Mark Full Color.svg';
import { HashLink } from 'react-router-hash-link';

const Header = () => {
    const { translate, language, switchLanguage } = useLanguage();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 40);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    const handleMenuToggle = () => {
        setMenuOpen((prev) => !prev);
    };

    return (
        <header className={scrolled ? 'scrolled' : ''}>
            <nav>
                <div className="logo">
                    <Link to="/">
                        <Logo title="86 ICE!" className="logo-svg" />
                    </Link>
                </div>
                <div className="nav-inner">
                    <div className="language-switcher">
                        <button
                            onClick={() => switchLanguage('en')}
                            className={language === 'en' ? 'active' : ''}
                        >
                            EN
                        </button>
                        <button
                            onClick={() => switchLanguage('es')}
                            className={language === 'es' ? 'active' : ''}
                        >
                            ES
                        </button>
                    </div>
                    <button
                        className={`hamburger${menuOpen ? ' open' : ''}`}
                        aria-label="Toggle menu"
                        onClick={handleMenuToggle}
                    >
                        <span />
                        <span />
                        <span />
                    </button>

                    <ul className={`nav-links${menuOpen ? ' show' : ''}`}>
                        <li>
                            <Link to="/restaurant-goers" className={isActive('/restaurant-goers')}>
                                {translate('NAV_RESTAURANT_GOERS')}
                            </Link>
                        </li>
                        <li>
                            <Link to="/restaurant-workers" className={isActive('/restaurant-workers')}>
                                {translate('NAV_RESTAURANT_WORKERS')}
                            </Link>
                        </li>
                        <li>
                            <Link to="/restaurant-owners" className={isActive('/restaurant-owners')}>
                                {translate('NAV_RESTAURANT_OWNERS')}
                            </Link>
                        </li>

                        <li>
                            <Link to="/report-an-incident" className={isActive('/report-an-incident')}>
                                {translate('NAV_REPORT')}
                            </Link>
                        </li>

                    </ul>
                </div>

            </nav>
        </header>
    );
};

export default Header;